import React from "react";
import { Link } from "react-router-dom";
import UserInviteTermsAcceptance from "./UserInviteTermsAcceptance";
import VendorInviteTermsAcceptance from "./VendorInviteTermsAcceptance";
import SignupTermsAcceptance from "./Signup/SignupTermsAcceptance";
import LegalDocumentLayout from "./Legal/LegalDocumentLayout";

// Dev-only gallery of every surface carrying the AXARIS wordmark, so the branding can be
// reviewed without provisioning a user or walking an invite flow. Registered in App.js
// behind NODE_ENV === 'development' — never routed in a production build.

const noop = () => {};

const Section = ({ title, file, note, children }) => (
  <section className="mb-10">
    <div className="px-4 py-3 bg-[#0C0E16] text-white">
      <h2 className="text-sm font-semibold">{title}</h2>
      <p className="text-xs text-gray-400 font-mono mt-0.5">{file}</p>
      {note && <p className="text-xs text-amber-300 mt-1">{note}</p>}
    </div>
    <div className="border border-[#e5e5e5] border-t-0">{children}</div>
  </section>
);

const BrandPreview = () => (
  <div className="min-h-screen bg-white">
    <div className="px-4 py-5 border-b border-[#e5e5e5]">
      <h1 className="text-lg font-semibold text-[#0C0E16]">AXARIS wordmark preview</h1>
      <p className="text-sm text-gray-500 mt-1">
        Dev-only. These routes are already public — open them directly:{" "}
        <Link className="underline" to="/login">/login</Link>{" · "}
        <Link className="underline" to="/invite/accept">/invite/accept</Link>{" · "}
        <Link className="underline" to="/invite/callback">/invite/callback</Link>{" · "}
        <Link className="underline" to="/legal/privacy-policy">/legal/privacy-policy</Link>{" · "}
        <Link className="underline" to="/signup">/signup</Link>
      </p>
      <p className="text-sm text-gray-500 mt-1">
        The consent steps below are mid-flow sub-components, so they are rendered here with mock props.
      </p>
    </div>

    <div className="max-w-[900px] mx-auto py-8">
      <Section
        title="Signup — terms step"
        file="components/Signup/SignupTermsAcceptance.js"
        note="Reachable for real at /signup after filling the form."
      >
        <div className="flex justify-center p-8 bg-[#fafafa]">
          <SignupTermsAcceptance onAccept={noop} onDecline={noop} loading={false} />
        </div>
      </Section>

      <Section
        title="Invited user — terms step"
        file="components/UserInviteTermsAcceptance.js"
        note="Reachable for real at /invite/callback with a valid invite token."
      >
        <UserInviteTermsAcceptance
          onAccept={noop}
          onDecline={noop}
          loading={false}
          inviteDetails={{
            role: "RISK_MANAGER",
            organizationName: "Contoso Ltd",
            email: "sample.user@contoso.com",
          }}
        />
      </Section>

      <Section
        title="Vendor invite — terms step"
        file="components/VendorInviteTermsAcceptance.js"
        note="No importer found in src/ — this component appears to be unrouted today."
      >
        <VendorInviteTermsAcceptance
          onAccept={noop}
          onDecline={noop}
          loading={false}
          inviteDetails={{
            organizationName: "Contoso Ltd",
            assessmentName: "Annual Vendor Security Review",
            accessExpiresDays: 30,
          }}
        />
      </Section>

      <Section title="Legal document header" file="components/Legal/LegalDocumentLayout.js">
        <LegalDocumentLayout title="Terms of Use" subtitle="Last updated 22 August 2026">
          <p className="text-sm text-gray-500">Document body renders here.</p>
        </LegalDocumentLayout>
      </Section>
    </div>
  </div>
);

export default BrandPreview;
